import React, { Fragment, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'
import FilterSearchDocuments from 'Components/TableSearchDocuments/FiltersSearchDocuments/FilterSearchDocuments'
import SearchDocumentsNumberedPagination from 'Components/TableSearchDocuments/SearchDocumentsPagination/SearchDocumentsNumberedPagination'
import DispatchNumberPopover from 'Components/ActionTable/components/DispatchNumberPopover/DispatchNumberPopover'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions } from 'Utils/constants'
import { searchSalesOrders } from 'api/mdl11/mdl11.services'
import { SearchSalesDocumentsProvider } from 'state/context/SearchSalesDocumentsContext'
import { useColumnSearchSaleOrderWeb } from './hooks/useColumnSearchSaleOrderWeb'
import {
  buildWebSalesOrderSearchPayload,
  webSalesOrderFilterFields,
  webSalesOrderInitialFilters,
} from './searchWebSalesOrderDocuments.config'
import WebSalesOrderWarehouseFilter from './WebSalesOrderWarehouseFilter'
import './SearchSaleOrderWeb.css'

const WebSalesOrderFilter = () => (
  <FilterSearchDocuments
    fields={webSalesOrderFilterFields}
    statusFilterKey="salesOrder"
    filterButtonTestId="btn-filter-web-sales-orders"
    clearButtonTestId="btn-clear-filters-web-sales-orders"
    extraFields={<WebSalesOrderWarehouseFilter />}
  />
)

function SearchSaleOrderWeb() {
  const { columns, dispatchPopover, setDispatchPopover } =
    useColumnSearchSaleOrderWeb()
  const canUserViewAllOrdersWeb = useValidatePermission(
    VAPermissions.viewAllOrdersWeb
  )
  const isCustomer = useSelector(state => state.login.isCustomer)
  const userId = useSelector(
    state => state.login.user?.AuthenticationInfo?.UserId
  )
  const warehouseId = useSelector(state => state.company.WarehouseId)
  const initialFilters = useMemo(
    () => ({
      ...webSalesOrderInitialFilters,
      allWarehouses: canUserViewAllOrdersWeb,
      salesAgentId: isCustomer ? userId : null,
    }),
    [canUserViewAllOrdersWeb, isCustomer, userId]
  )

  // Don't search before the data that scopes it (salesAgentId/warehouseId) loads.
  const isWaitingForScope =
    (isCustomer && !userId) || (!canUserViewAllOrdersWeb && !warehouseId)

  return (
    <SearchSalesDocumentsProvider
      fetcher={searchSalesOrders}
      initialFilters={initialFilters}
      buildPayload={buildWebSalesOrderSearchPayload}
      enabled={!isWaitingForScope}>
      <Fragment>
        <Navigation />
        <section
          className="common-search-content"
          data-testid="container-search-sale-order-web">
          <header className="common-search-header">
            <h2>{t('SEARCH_QUOTATION_T.SALES_ORDER')}</h2>
          </header>
          <TableSearchDocuments
            columns={columns}
            FilterComponent={WebSalesOrderFilter}
            PaginationComponent={SearchDocumentsNumberedPagination}
          />
        </section>
        <DispatchNumberPopover
          props={{
            dispatchValue: dispatchPopover,
            setDispatchValue: setDispatchPopover,
          }}
        />
      </Fragment>
    </SearchSalesDocumentsProvider>
  )
}

export default SearchSaleOrderWeb
